import React, { useState } from "react";
import { ArrowLeft } from "lucide-react";
import ColorPalette from "../ColorPalette"; // Assurez-vous que le chemin est correct
import { MdClose } from 'react-icons/md'; // Icône de croix

const CategoryEditor = ({ category, onClose }) => {
  const [currentColor, setCurrentColor] = useState(category.color || "bg-green-500");
  const [showPalette, setShowPalette] = useState(false);
  const [categoryImage, setCategoryImage] = useState(null); // Nouvel état pour l'image

  // Gère la sélection de la couleur
  const handleColorChange = (color) => {
    setCurrentColor(color);
    setShowPalette(false);
  };

  // Gère la sélection de l'image
  const handleImageChange = (image) => {
    setCategoryImage(image); // Met à jour l'image de la catégorie
  };

  // Affiche ou cache la palette
  const togglePalette = () => {
    setShowPalette((prev) => !prev);
  };



  const [isDeleted, setIsDeleted] = useState(false); // État de suppression

  // Fonction pour supprimer l'image
  const handleDeleteImage = () => {
    setCategoryImage(null);  // Supprime l'image
    setIsDeleted(true);      // Marque l'image comme supprimée
  };



  return (
    <div>
      <div className="flex flex-col min-h-screen">
        <header className="flex items-center justify-between p-4 border-b">
          <div className="flex items-center">
            <button
              onClick={onClose}
              className="flex items-center text-gray-600 hover:text-gray-900"
            >
              <ArrowLeft className="w-5 h-5 mr-2" />
              Retour
            </button>
          </div>
          <h1 className="text-lg font-medium">Edition catégorie</h1>
          <button className="text-emerald-500 font-medium">Enregistrer</button>
        </header>

        <div className="flex flex-col items-center p-1 space-y-4">
          {/* <div
            className={`w-24 h-24 ${currentColor} rounded-lg flex items-center justify-center`}
          >
            {categoryImage ? (
              <img
                src={categoryImage}
                alt="Category"
                className="w-full h-full object-cover rounded-lg"
              />
            ) : (
              <span className="text-white text-xl">{category.name.substring(0, 1)}</span>
            )}
          </div> */}
       <div
  className={`w-24 h-24 ${isDeleted || !categoryImage ? currentColor : 'bg-transparent'} rounded-lg flex items-center justify-center relative`}
>
  {categoryImage ? (
    <>
    <img
      src={categoryImage}
      alt="Category"
      className="w-full h-full object-cover rounded-lg"
    />
    <button
    onClick={handleDeleteImage}
    className="absolute top-1 right-1 bg-white rounded-full p-1 text-gray-600 hover:text-gray-900"
  >
    <MdClose className="text-sm" />
  </button>
  </>
  ) : (
    <span className="text-white text-xl">{category.name.substring(0, 1)}</span>
  )}

  {/* Icône de suppression toujours affichée */}

</div>



          <button onClick={togglePalette} className="text-gray-600 text-sm mt-2">
            Éditer Couleur
          </button>

          <div className="w-full max-w-md mt-6">
  <label
    htmlFor="categoryName"
    className="text-sm font-medium text-gray-700 mb-2 block "
    style={{ marginLeft: "9px" }}
  >
    Categories
  </label>
  <input
    type="text"
    id="categoryName"
    value={category.name}
    className="w-full p-2 border-b text-left focus:outline-none focus:border-emerald-500"
  />
</div>



          <div className="w-full max-w-md mt-8">
            <button className="w-full py-3 text-red-500 border border-red-500 rounded-lg hover:bg-red-50">
              Supprimer la catégorie
            </button>
          </div>
        </div>
      </div>

      {/* Show Color Palette */}
      {showPalette && (
        <div className="fixed inset-0 z-50 flex md:items-start bg-opacity-50">
          <div className="w-full bg-white min-h-screen md:min-h-0 md:ml-[250px] md:h-auto transition-transform duration-300 ease-out">
            <ColorPalette
              initialColor={currentColor}
              onClose={togglePalette}
              onColorChange={handleColorChange}
              onImageChange={handleImageChange} // Passer la fonction pour gérer l'image
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryEditor;
